export const EstadoDocumento = {
    PENDIENTE_VISUALIZAR: "PENDIENTE_VISUALIZAR",
    VISUALIZADO: "VISUALIZADO",
    FIRMADO: "FIRMADO",
    //agregados para consulta documento portal colaborador
    PENDIENTE: "PENDIENTE",
    CARGADO: "CARGADO",
    GENERADO: "GENERADO",
    ERROR: "ERROR"
}